export const EyeOffIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.56849 5.9827C2.7597 7.53968 1.25036 9.41852 0.118844 11.5272C-0.121125 11.9744 0.0898986 12.4357 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7926C1.40207 14.5787 2.15683 15.6294 3.14546 16.684C5.10448 18.7736 8.10049 21 12 21C14.0534 20.9833 16.1021 20.3498 17.8261 19.2403L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L1.70711 0.292893ZM16.3714 17.7856L14.0497 15.464C13.4379 15.8475 12.721 16.0614 11.9957 16.0742C10.9216 16.0932 9.85641 15.663 9.09674 14.9033C8.33707 14.1436 7.90684 13.0785 7.92579 12.0043C7.93859 11.279 8.15252 10.5621 8.53604 9.95028L5.9871 7.40134C4.45031 8.7014 3.14935 10.2582 2.14257 12.0032C2.53338 12.6782 3.37499 14.0046 4.60454 15.3161C6.39395 17.2248 8.89512 18.9969 11.9918 19C13.5373 18.9734 15.0437 18.5524 16.3714 17.7856ZM10.0279 11.4421C9.96372 11.6346 9.92907 11.836 9.92548 12.0396C9.916 12.5767 10.1311 13.1092 10.511 13.4891C10.8908 13.8689 11.4234 14.084 11.9604 14.0745C12.164 14.071 12.3655 14.0363 12.5579 13.9721L10.0279 11.4421Z"
          fill="currentColor"
        />
        <path
          d="M19.3955 8.68397C17.6186 6.78864 15.14 5.00035 12.0732 5.00035C10.7344 5.00035 9.75 5.39453 9.24609 4.92969C8.97937 4.68364 8.83881 4.31458 8.93838 3.96563C9.03796 3.61668 9.31876 3.34905 9.67209 3.26634C10.4355 3.08765 11.2171 2.99828 12.0012 3.00003C15.9001 3.00046 18.8957 5.22667 20.8545 7.31608C21.8432 8.37062 22.5979 9.42134 23.1057 10.2075C23.3601 10.6015 23.5542 10.9317 23.686 11.166C23.9161 11.575 24.1303 12.0067 23.8819 12.4714C23.2421 13.6684 22.479 14.7953 21.6052 15.8339C21.4247 16.0483 21.1627 16.1771 20.8827 16.1891C20.6027 16.2011 20.3593 16.1521 20.1326 15.8968C19.778 15.4976 19.6399 14.9449 20.7526 13.6877C21.1532 13.1462 21.5223 12.582 21.858 11.9978C21.4674 11.3231 20.6256 9.99609 19.3955 8.68397Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
